((adTemplateDistrictMap) => {
  /* Get elements on the page. */
  const accordionDistrictList = document.getElementById(
    'district-map-band-accordion',
  );
  const accordionDistrictListButtons =
    accordionDistrictList.getElementsByTagName('button');
  const accordionDistrictMap = document.getElementById('ns-district-map');
  const accordionDistrictMapAreas =
    accordionDistrictMap.getElementsByTagName('path');

  /* Set up event listeners. */
  accordionDistrictList.addEventListener('show.bs.collapse', (event) => {
    const { mapKey } = event.target.dataset;
    adTemplateDistrictMap.mapDistrictOn(mapKey);
  });

  accordionDistrictList.addEventListener('hide.bs.collapse', (event) => {
    const { mapKey } = event.target.dataset;
    adTemplateDistrictMap.mapDistrictOff(mapKey);
  });

  Array.from(accordionDistrictListButtons).forEach((button) => {
    button.addEventListener('focus', (event) => {
      const { mapKey } = event.target.dataset;
      adTemplateDistrictMap.focusMapDistrictOn(mapKey);
    });

    button.addEventListener('blur', (event) => {
      const { mapKey } = event.target.dataset;
      adTemplateDistrictMap.focusMapDistrictOff(mapKey);
    });

    button.addEventListener('mouseenter', (event) => {
      const { mapKey } = event.target.dataset;
      adTemplateDistrictMap.focusMapDistrictOn(mapKey);
    });

    button.addEventListener('mouseleave', (event) => {
      const { mapKey } = event.target.dataset;
      adTemplateDistrictMap.focusMapDistrictOff(mapKey);
    });
  });

  Array.from(accordionDistrictMapAreas).forEach((area) => {
    area.addEventListener('click', (event) => {
      const { id } = event.target;
      adTemplateDistrictMap.toggleAccordionFromMap(
        id.replace('ns-district-map-', ''),
      );
    });

    area.addEventListener('mouseenter', (event) => {
      const { id } = event.target;
      adTemplateDistrictMap.focusAccordionFromMapOn(
        id.replace('ns-district-map-', ''),
      );
    });

    area.addEventListener('mouseleave', (event) => {
      const { id } = event.target;
      adTemplateDistrictMap.focusAccordionFromMapOff(
        id.replace('ns-district-map-', ''),
      );
    });
  });

  /* Helper functions to act on events. */

  /**
   * Highlight the region of the open accordion on the map.
   * @param {string} mapKey Id to look up.
   */
  adTemplateDistrictMap.mapDistrictOn = (mapKey) => {
    const district = document.getElementById(`ns-district-map-${mapKey}`);
    district.classList.add('active');
  };

  /**
   * Remove highlight the region of the closed accordion on the map.
   * @param {string} mapKey Id to look up.
   */
  adTemplateDistrictMap.mapDistrictOff = (mapKey) => {
    const district = document.getElementById(`ns-district-map-${mapKey}`);
    district.classList.remove('active');
  };

  /**
   * Toggle active accordion based on map key.
   * @param {string} pathId Id to look up.
   */
  adTemplateDistrictMap.toggleAccordionFromMap = (pathId) => {
    const bsAccordionButton = document.querySelector(
      `[data-bs-target="#collapse-${pathId}"]`,
    );
    bsAccordionButton.click();
  };

  /**
   * Highlight the region of the hovered accordion on the map.
   * @param {string} mapKey Id to look up.
   */
  adTemplateDistrictMap.focusMapDistrictOn = (mapKey) => {
    const district = document.getElementById(`ns-district-map-${mapKey}`);
    district.classList.add('focus');
  };

  /**
   * Remove highlight the region of the hovered accordion on the map.
   * @param {string} mapKey Id to look up.
   */
  adTemplateDistrictMap.focusMapDistrictOff = (mapKey) => {
    const district = document.getElementById(`ns-district-map-${mapKey}`);
    district.classList.remove('focus');
  };

  /**
   * Highlight accordion based on map key.
   * @param {string} pathId Id to look up.
   */
  adTemplateDistrictMap.focusAccordionFromMapOn = (pathId) => {
    const bsAccordionButton = document.querySelector(
      `[data-bs-target="#collapse-${pathId}"]`,
    );
    bsAccordionButton.classList.add('focus');
  };

  /**
   * Remove highlight accordion based on map key.
   * @param {string} pathId Id to look up.
   */
  adTemplateDistrictMap.focusAccordionFromMapOff = (pathId) => {
    const bsAccordionButton = document.querySelector(
      `[data-bs-target="#collapse-${pathId}"]`,
    );
    bsAccordionButton.classList.remove('focus');
  };
})((window.adTemplateDistrictMap = window.adTemplateDistrictMap || {}));
